import { getTagColorsFromName } from '@/shared/lib/utils/grafana/tag-colors';
import { Badge, CloseButton } from '@mantine/core';
import { MultiSelectCreatableProps } from '@/shared/ui/creatable-select';

export const tagRender: MultiSelectCreatableProps['renderPill'] = (
  item,
  onClose,
) => {
  const { label, value } = item;

  return (
    <Badge
      color={getTagColorsFromName(label as string)}
      autoContrast
      rightSection={
        <CloseButton
          variant={'transparent'}
          onClick={() => onClose(String(value))}
          size={'xs'}
        />
      }

      // style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Badge>
  );
};